module.exports = __webpack_public_path__ + "static/female04-384d7c7b65d582b8002a70980a1f8a50.png";